import {Form, Select} from "antd";
import React from "react";
const {Option} = Select;
export default (props)=>{
    let {
        displayConditionStateKey,
        displayConditionStateValue,
        data,label,name,message,
        handleChange,getValue,
        recordOptionKey,recordOptionValue,
        recordOptionDisplay
    }=props;

    if (displayConditionStateKey === displayConditionStateValue) {
        return
    }
    let ls = data;
    return (
        <Form.Item
            label={label}
            name={name}
            rules={[{required: true, message: message}]}
        >
            <Select
                style={{width: "100%"}}
                onChange={(value) => handleChange(value, name)}
                value={getValue}
            >
                {ls.map((record, index) => {
                    return (
                        <Option
                            key={record[recordOptionKey]}
                            value={record[recordOptionValue]}
                        >
                            {record[recordOptionDisplay]}
                        </Option>
                    )
                })}
            </Select>
        </Form.Item>

    )
}
